export abstract class ResourceIdentifierModel {
  public abstract readonly resourceIdentifier: string;
  public abstract readonly queryParams: URLSearchParams | undefined;
}
